import React from 'react';
import { Link } from 'react-router-dom';
import HeaderSlider from '../../pages/HeaderSlider';


const FrontBackManpower = () => {
    return (
        <>
            {/* <!-- Breadcromb Area Start --> */}
            <section className="bleezy-breadcromb-area">
                {/* <div className="breadcromb-top front-back-manpower">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="breadcromb-top-text">
                                    <h2 className="banner-heading">Front & Back office Manpower</h2>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <HeaderSlider src="../../assets/img/Gallery/Bouncer4.jpeg" title="Front & Back office Manpower" />
                    
                    
                {/* </div> */}
                <div className="breadcromb-bottom">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="breadcromb-bottom-text">
                                    <ul>
                                        <li><Link to="/">home</Link></li>
                                        <li><a href="#"><i className="fa fa-long-arrow-right"></i></a></li>
                                        <li>Front & Back office Manpower</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Breadcromb Area End --> */}


            <section class="bleezy-blog-page-area" style={{ paddingTop: '15px', paddingBottom: '15px' }}>
                <div class="container">
                    <div class="mid-title  mb-5 "><h2 class="heading-with-border"><strong>Front & Back Office Manpower</strong></h2>
                        <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">
                            Outsourcing of manpower is not a new phenomena in India, but it gained momentum since 2006. Outsourcing of manpower is not only a trend in private sector, but also in public sector and government establishment, who are practicing this very effectively and efficiently. More and more organisation are successfully adopting it, as it protects them against inefficiency of staff, high replacement cost, compliance issue and complexity of labour laws.
                        </p>
                        <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">
                            Often people get confused with hiring manpower and outsourcing of manpower. When you outsource the work to a third party, they get the job done on your behalf and charge you on hourly, monthly or on assignment basis. Whereas, when you hire manpower resource, they are just like your employee but on contractual basis. Hiring manpower service is better than outsourcing of work whether in the long run or in short term due to the following factors:
                        </p>


                        <p className="octo-para" style={{ marginLeft: '20px' }}>
                            It is much cheaper than outsourcing<br />
                            Gives you complete control over the resource you hire<br />
                            They can work in customise way by using your systems and software<br />
                            You can hire as many as you wish and till the time you need<br />
                        </p>
                        <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15 ">
                            Our manpower service in India gives you the freedom to hire as per your desire. You can hire manpower in India on monthly retainer ship basis. There is no restrictions on number of manpower you want to hire and the duration for which you want to hire. Essentially temp staff and manpower service is of same nature, but manpower service is a wider concept and it includes temp staff under its umbrella.
                        </p>

                        <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">
                            We have achieved great niche in providing manpower service in India. We are serving many private and government sector clients. When you hire manpower from us, you get the following benefits:
                        </p>
                        <ul class="list">
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Proper Documentation</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Full compliance to labour laws</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Medical checkup, if required</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Manpower on our payroll</li>
                        </ul>

                        <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">
                            We provide staff for back office and front office work. We also provide labours for factory and godown.
                        </p>
                        <h3 className="sub-heading-page sub-heading-m-t-15 sub-heading-m-b-15"><strong>Labour Service</strong></h3>
                        <h3 className="sub-heading-page sub-heading-m-t-15 sub-heading-m-b-15"><strong>Hire Carpenter, Plumber, Electrician, Driver, Gardener, Cook, Nurse and Caretaker on our payroll</strong></h3>
                        <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">
                            We have recently added service of providing Carpenter, Plumber, Electrician, Driver, Gardener, Cook, Nurse and Caretaker in our bouquet of services. Our existing satisfied clients who have hired us for security and housekeeping services, wished to deal with single vendor for manpower requirement too. To carry our philosophy forward, Octopuss has started labour manpower services, for all non-core activity requirement. Within a short span of time, we have successfully deployed large number of manpower in India. If you are looking for professional labour service provider in India, contact us for the best quote.
                        </p>
                        <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">
                            We have large network and expertise to help you in hiring Carpenter, Plumber, Electrician, Driver, Gardener, Cook, Nurse and Caretaker in India. They will be on our payroll and we will take care of compliance. You can hire as per your requirement and at reasonable cost.
                        </p>
                    </div>
                </div>
            </section>
        </>
    )
}

export default FrontBackManpower;
